import request from "@/utils/request";
import qs from "qs";

// 获取产品详情
export function xcCustomer(params) {
  return request({
    url: "api/xcCustomer/" + "?" + qs.stringify(params, { indices: false }),
    method: "get",
  });
}

export function xcMaintenance(params) {
  return request({
    url: "api/xcMaintenance/" + "?" + qs.stringify(params, { indices: false }),
    method: "get",
  });
}

export function addXcMaintenance(xcMaintenance) {
  return request({
    url: "api/xcMaintenance",
    method: "post",
    data: xcMaintenance,
  });
}

export function getFavoriteStatus() {
  return request({
    url: "api/getXcCustomerIdsByChannel",
    method: "get",
  });
}

export function addCustomer(xcCustomer) {
  return request({
    url: "api/addXcCustomerByChannel",
    method: "post",
    data: xcCustomer,
  });
}

// 修改XcCustomer级别
export function editXcCustomerLevel(id, level) {
  return request({
    url: "api/xcCustomer/" + id + "/" + level,
    method: "put",
  });
}

// 将客户放回公海
export function delXcCustomer(channelId, enterpriseId) {
  return request({
    url: "api/xcCustomer/" + channelId + "/" + enterpriseId,
    method: "get",
  });
}

// 查询企业名称
export function xcCompanySearch(companyName) {
  return request({
    url: "api/apply/xcCompanySearch/" + companyName,
    method: "Get",
  });
}

// 查询企业名称 限流版
export function xcCompanySearchCus(companyName) {
  return request({
    url: "cus/apply/limit/xcCompanySearch/" + companyName,
    method: "Get",
  });
}

// 通过企业名称查询企业信息
export function xcCompanyInfo(companyName) {
  return request({
    url: "api/apply/xcCompanyInfo/" + companyName,
    method: "Get",
  });
}


// 渠道新增客户 通过企业名称新增
export function addXcCustomerByCompanyName(data) {
  return request({
    url: "api/addXcCustomerByCompanyName",
    method: "post",
    data,
  });
}

// 获取企业详情信息
export function getXcCustomerDetail(id) {
  return request({
    url: "api/getXcCustomerDetail/" + id,
    method: "Get",
  });
}

// 通过id获取渠道信息
export function getDynamicDict(dictName) {
  return request({
    url: 'api/dict/getDynamicDict/' + dictName,
    method: 'get'
  })
}


// 导出客户数据
export function xcCustomerExport() {
  return request({
    url: 'api/xcCustomer/export',
    method: 'get'
  })
}

// 渠道获取补贴信息客户数据
export function xcCzpt(params) {
  return request({
    url: "api/xcCzpt/" + "?" + qs.stringify(params, { indices: false }),
    method: "get",
  });
}
// 渠道获取资产配置客户数据
export function xcZcpz(params) {
  return request({
    url: "api/xcZcpz/" + "?" + qs.stringify(params, { indices: false }),
    method: "get",
  });
}
// 渠道获取账户管理客户数据
export function xcZhgl(params) {
  return request({
    url: "api/xcZhgl/" + "?" + qs.stringify(params, { indices: false }),
    method: "get",
  });
}
// 渠道获取债务优化客户数据
export function xcZwyh(params) {
  return request({
    url: "api/xcZwyh/" + "?" + qs.stringify(params, { indices: true }),
    method: "get",
  });
}
// 渠道获取信用修复客户数据
export function xcXyxf(params) {
  return request({
    url: "api/xcCreditRepair/" + "?" + qs.stringify(params, { indices: true }),
    method: "get",
  });
}


// WEBPACK FOOTER //
// ./src/api/xcCustomer.js